/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { DASHBOARD_FORM_START } from 'state/action-types';

import { createReducer } from 'state/utils';

const dashboardId = createReducer(null, {
	[DASHBOARD_FORM_START]: (state, action) => {
		return action.payload.dashboardId || null;
	},
});

export default combineReducers({
	dashboardId,
});
